import { ActivatedRouteSnapshot, DetachedRouteHandle, RouteReuseStrategy } from "@angular/router";

/**Komponenten resuse  bei Routing
 * config z.B. => data: {     shouldReuseRoute: true,     reuseRoutesFrom: ['pletzedit']
 */
export class SortRouteReuseStrategy implements RouteReuseStrategy {

  private routeStore = new Map<string, DetachedRouteHandle>();
  private routeLeftFrom: string = '';

  constructor() { }


  clear() {
    this.routeStore.clear();  
  }

  shouldDetach(route: ActivatedRouteSnapshot): boolean {
    this.routeLeftFrom = route.routeConfig.path;
    return route.data.shouldReuseRoute || false;

  }
  store(route: ActivatedRouteSnapshot, handle: DetachedRouteHandle): void {
    this.routeStore.set(route.routeConfig.path, handle);
  }
  shouldAttach(route: ActivatedRouteSnapshot): boolean {
    if (route.url == undefined) return false;
    const wasRoutePreviouslyDetached = !!this.routeStore.get(route.url.join('/') || (route.parent && route.parent.url.join('/')))
      || this.routeStore.get('view/:sortimentid/:userid');
    if (wasRoutePreviouslyDetached) {
      const reuseRouteFromVerified = route.data && route.data.reuseRoutesFrom && route.data.reuseRoutesFrom.indexOf(this.routeLeftFrom) > -1;
      if (reuseRouteFromVerified) {
        return true;
      }
    }
    return false;
  }
  retrieve(route: ActivatedRouteSnapshot): DetachedRouteHandle {
    const path = route.routeConfig.path;
    return this.routeStore.get(path);
  }
  shouldReuseRoute(future: ActivatedRouteSnapshot, curr: ActivatedRouteSnapshot): boolean {
    return future.routeConfig === curr.routeConfig;
  }
}
